export default __webpack_public_path__ + "static/job-6276aea0dc79bc05d9e45f60415ac2ab.png";